import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  AutoComplete,
  Icon,
  message,
  Tooltip,
  Upload,
  Spin,
  Select
} from 'antd'
import ReactTable from 'react-table'
import ReactQuill from 'react-quill'
import moment from 'moment'
import styled from 'styled-components'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/jobSiteJobMinuteActions'
import { actions as auditActions } from '../../../redux/modules/auditActions'
import { convertToOption, filterCaseInsensitive } from '../../../util'
import 'react-quill/dist/quill.snow.css'
import config from '../../../config'
import _ from 'lodash'
const { API_BASE } = config
const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}
const Option = Select.Option
const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

class JobSiteJobMinutes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      bodyText: '',
      currentRevisionNumberPrint: 1
    }

    this.props.jobSiteJobMinutesRefresh({
      jobId: this.props.jobId
    })
    this.props.getJobMinuteTemplates()
  }

  componentDidUpdate(prevProps) {
    // update the current version for printing
    if (prevProps.auditActions.loading !== this.props.auditActions.loading) {
      const revisions = _.get(this.props, 'auditActions.revisions.data')
      if (revisions) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].revision
        })
      }
    }
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.props.getAuditRevisions({
      targetId: row.id,
      table: 'job_minute'
    })
    this.props.getAttachments({
      jobMinuteId: row.id
    })
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row,
      bodyText: row.body
    })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null,
      bodyText: ''
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false, bodyText: '' })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (this.state.currentId === 0) {
        this.props.createJobMinute({
          jobId: this.props.jobId,
          content: values,
          body: this.state.bodyText,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateJobMinute({
          jobId: this.props.jobId,
          jobMinuteId: this.state.currentId,
          content: values,
          body: this.state.bodyText,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false, bodyText: '' })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteJobMinute({
      jobId: this.props.jobId,
      jobMinuteId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false,
      bodyText: ''
    })
  }

  handleChange = value => {
    this.setState({ bodyText: value })
  }

  handleTemplateSelect = event => {
    const form = this.props.form
    const selectedTemplate = this.props.jobSiteJobMinuteActions.jobMinuteTemplates.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )

    form.setFieldsValue({
      attendees: selectedTemplate[0].attendees,
      subject: selectedTemplate[0].subject
    })

    this.setState({
      bodyText: selectedTemplate[0].body
    })
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_minute')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('jobMinuteId', this.state.currentId)

    this.props.uploadAttachment({
      formData: formData,
      jobMinuteId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      jobMinuteId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      jobMinuteId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }
  handleRevisionChange = value => {
    const form = this.props.form
    const revisionsObject = this.props.auditActions.revisions.data.find(x => x.id === value)
    const revisions = JSON.parse(revisionsObject.json_patch)
    const revisionNumber = revisionsObject.revision

    // set revision numner for printing
    this.setState({
      currentRevisionNumberPrint: revisionNumber
    })

    let changes = {}
    revisions.forEach(revision => {
      const fieldName = revision.path.substring(1, revision.path.length)
      if (fieldName === 'body') {
        this.setState(prevState => {
          const body = revision.value.toString()
          return { ...prevState, bodyText: body }
        })
      }
      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        changes[fieldName] = revision.value.toString()
      }
    })

    form.setFieldsValue(changes)
  }
  render() {
    const { contentData, currentRevisionNumberPrint } = this.state

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form
    const revisions =
      this.props.auditActions &&
      this.props.auditActions.revisions &&
      this.props.auditActions.revisions.data

    const loadingRevision = this.props.auditActions && this.props.auditActions.loading

    if (!this.props.jobSiteJobMinuteActions.jobSiteJobMinutes) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Job Minutes"
          okText={contentData ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={1020}
          maskClosable={false}
        >
          <Form layout="vertical">
            {contentData && (
              <div className="row">
                <div className="col-md-12 text-right">
                  <a
                    href={`${API_BASE}/api/job/job_site_job_minutes/print/${
                      contentData.id
                    }?revision=${currentRevisionNumberPrint}`}
                    target="_blank"
                  >
                    <Button icon="printer" className="marginRight10" />
                  </a>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-9">
                <FormItem label="Template">
                  {getFieldDecorator('job_minute_template_id', {
                    initialValue: contentData ? contentData.template_name : ''
                  })(
                    <AutoComplete
                      dataSource={convertToOption(
                        this.props.jobSiteJobMinuteActions &&
                          this.props.jobSiteJobMinuteActions.jobMinuteTemplates &&
                          this.props.jobSiteJobMinuteActions.jobMinuteTemplates.data
                      )}
                      onSelect={this.handleTemplateSelect}
                      filterOption={(inputValue, option) =>
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      onChange={this.handleTemplateChange}
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>
              </div>
              {contentData && (
                <div className="col-md-3">
                  <FormItem label="Revision">
                    {loadingRevision ? (
                      <Spin size="small" />
                    ) : (
                      <Select
                        defaultValue={
                          revisions && revisions.length > 0
                            ? revisions[revisions.length - 1].id
                            : null
                        }
                        onChange={this.handleRevisionChange}
                      >
                        {revisions &&
                          revisions.map(revision => (
                            <Option key={revision.id} value={revision.id}>
                              {revision.revision}
                            </Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </div>
              )}
            </div>
            <FormItem label="Attendees">
              {getFieldDecorator('attendees', {
                initialValue: contentData ? contentData.attendees : 'NA'
              })(<Input placeholder="Type in meeting attendees..." />)}
            </FormItem>
            <FormItem label="Subject">
              {getFieldDecorator('subject', {
                initialValue: contentData ? contentData.subject : ''
              })(<Input placeholder="Type in the subject..." />)}
            </FormItem>
            <ReactQuill value={this.state.bodyText} onChange={this.handleChange} />
            {contentData && (
              <FilesUploadContainer>
                <div className="row">
                  <div className="col-md-6">
                    <h6>
                      <Icon type="file" /> Job Minute Files
                    </h6>
                  </div>
                  <div className="col-md-6 text-right">
                    {this.props.jobSiteJobMinuteActions &&
                      this.props.jobSiteJobMinuteActions.uploadingAttachment && (
                        <div className="text-success">
                          <Icon type="loading" /> Uploading File(s)
                        </div>
                      )}
                    {this.props.jobSiteJobMinuteActions &&
                      this.props.jobSiteJobMinuteActions.deletingAttachment && (
                        <div className="text-danger">
                          <Icon type="loading" /> Deleting File(s)
                        </div>
                      )}
                  </div>
                </div>
                {this.props.jobSiteJobMinuteActions.jobSiteJobMinutesAttachments &&
                  this.props.jobSiteJobMinuteActions.jobSiteJobMinutesAttachments.data.length >
                    0 && (
                    <Spin spinning={this.props.jobSiteJobMinuteActions.loadingAttachments}>
                      <ReactTable
                        defaultPageSize={5}
                        data={this.props.jobSiteJobMinuteActions.jobSiteJobMinutesAttachments.data}
                        getTrProps={(state, rowInfo, column, instance) => ({
                          onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                        })}
                        defaultFilterMethod={filterCaseInsensitive}
                        columns={[
                          {
                            Header: 'Attached Files',
                            columns: [
                              {
                                Header: 'Filename',
                                id: 'filename',
                                accessor: 'filename',
                                Cell: d => (
                                  <Tooltip title={d.original.filename}>
                                    {d.original.filename}
                                  </Tooltip>
                                )
                              },
                              {
                                Header: 'Description',
                                id: 'description',
                                accessor: 'description',
                                Cell: d => (
                                  <Tooltip title={d.original.description}>
                                    {d.original.description}
                                  </Tooltip>
                                )
                              },
                              {
                                Cell: row => (
                                  <Tooltip placement="left" title="Open this file on a new window">
                                    <a target="_blank" href={row.original.signedUrl}>
                                      <Icon type="export" className="fontSize20" />
                                    </a>
                                  </Tooltip>
                                ),
                                maxWidth: 35
                              }
                            ]
                          }
                        ]}
                        defaultSorted={[
                          {
                            id: 'id',
                            desc: true
                          }
                        ]}
                        className="-striped -highlight"
                      />
                    </Spin>
                  )}
                {this.state.attachmentDetailsVisible && (
                  <EditAttachmentContainer>
                    <EditAttachmentTitle>
                      <Icon type="edit" /> Edit Attachment Area
                    </EditAttachmentTitle>
                    <div>
                      <EditingFileContainer>
                        <Icon type="file" /> {this.state.attachmentName}
                      </EditingFileContainer>
                    </div>
                    <div className="row">
                      <div className="col-md-10">
                        <TextArea
                          placeholder="Describe the attachment..."
                          rows={4}
                          onChange={this.onDescriptionChange}
                          value={this.state.attachmentDescription}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-row mt-2">
                      <Button onClick={this.handleUpdateAttachmentDescription}>
                        <Icon type="save" /> OK
                      </Button>{' '}
                      <Popconfirm
                        title="Are you sure you want to delete this attachment?"
                        onConfirm={this.confirmAttachmentDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger" icon="delete" className="ml-2">
                          {' '}
                          DELETE
                        </Button>
                      </Popconfirm>
                    </div>
                  </EditAttachmentContainer>
                )}
                <br />
                <div>Upload Job Minute File(s)</div>
                <br />
                <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                  <Button>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              </FilesUploadContainer>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Job Minutes
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Minute
            </div>
          </div>
        </div>
        {this.props.jobSiteJobMinuteActions.jobSiteJobMinutes && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSiteJobMinuteActions.jobSiteJobMinutes.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'number',
                    maxWidth: 90,
                    className: 'textAlignCenter'
                  },
                  {
                    Header: 'Attendees',
                    id: 'attendees',
                    accessor: 'attendees',
                    Cell: d => (
                      <Tooltip title={d.original.attendees}>{d.original.attendees}</Tooltip>
                    ),
                    maxWidth: 150
                  },
                  {
                    Header: 'Subject',
                    id: 'subject',
                    accessor: 'subject',
                    Cell: d => <Tooltip title={d.original.subject}>{d.original.subject}</Tooltip>
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Created by',
                    id: 'created_by',
                    accessor: d => `${d.first_name} ${d.last_name}`,
                    minWidth: 70
                  },
                  {
                    Header: 'Updated by',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                    minWidth: 70
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobSiteJobMinuteActions, auditActions }, ownProps) => ({
  jobSiteJobMinuteActions,
  auditActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, auditActions), dispatch)
})

JobSiteJobMinutes.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteJobMinutes))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteJobMinutes.js